import { proxy } from 'valtio'
import { useSnapshot } from 'valtio/react'

export interface NodePreviewRequest {
  id: number
  nodeId: string
}

let nextRequestId = 0

export const nodePreviewStore = proxy<{
  request: NodePreviewRequest | null
  hoveredReferenceCount: number
}>({
  request: null,
  hoveredReferenceCount: 0,
})

export function setReferenceHovered(isHovered: boolean) {
  if (isHovered) {
    nodePreviewStore.hoveredReferenceCount += 1
  } else {
    nodePreviewStore.hoveredReferenceCount = Math.max(0, nodePreviewStore.hoveredReferenceCount - 1)
  }
}

export function isAnyReferenceHovered() {
  return nodePreviewStore.hoveredReferenceCount > 0
}

export function requestNodePreview(nodeId: string) {
  nextRequestId += 1
  nodePreviewStore.request = {
    id: nextRequestId,
    nodeId,
  }
}

export function useNodePreviewRequest() {
  return useSnapshot(nodePreviewStore).request
}

export function clearNodePreviewRequest(id: number) {
  if (nodePreviewStore.request?.id === id) {
    nodePreviewStore.request = null
  }
}
